export const portfolioCompanies = [
  {
    id: 1,
    slug: "biblebridge",
    tagline: "AI-Powered Bible Study Companion",
    sector: "Faith Tech",
    description: "AI-powered Bible study tools that explain context, connect themes across books, and make Scripture accessible without watering it down.",
    problem: "Most Bible study tools are either too academic for casual readers or too shallow for anyone wanting real understanding. There's no middle ground that's smart, simple, and actually rooted in Scripture.",
    solution: "Uses AI to break down passages in plain language, surface cross-references, and guide users through reading plans — all without replacing the text or adding denominational spin.",
    features: [
      "AI-powered verse explanation and context",
      "Cross-reference discovery across books",
      "Guided reading plans for beginners and deep studiers",
      "Bookmarking and personal notes",
      "Offline access to core features"
    ],
    audience: "Bible truth seekers who want to go deeper in Scripture but don't have a seminary degree — from new readers to lifelong studiers who want better tools.",
    category: "Faith Tech"
  },
  {
    id: 2,
    slug: "mybabylogger",
    tagline: "Cost-Effective Baby Tracking for Real Parents",
    sector: "Parenting",
    description: "A cost-effective baby tracking tool helps new parents log feedings, diapers, sleep, and milestones without the overwhelm. Clean, fast, and built for one-handed use at 3AM.",
    problem: "New parents are told to track everything — but the apps that do it well charge $10-$15/month or lock basic features behind a paywall. In a world where everything is getting more expensive, new parents shouldn't have to choose between tracking their baby's health and paying another subscription. Most alternatives are overdesigned, bloated, or built for investors, not families.",
    solution: "A relief for new parents. One-tap logging, clear summaries, and no paywall for the basics — at a price that doesn't add stress to an already stressful season. Built for real life, not a product demo.",
    features: [
      "One-tap logging for feeds, diapers, and sleep",
      "Daily and weekly summaries",
      "Milestone tracking with reminders",
      "Multi-caregiver support",
      "Export logs for pediatrician visits"
    ],
    audience: "New parents, growing families, and caregivers who want a no-nonsense, affordable way to track a baby's day without learning a new app or paying a premium.",
    category: "Parenting",
    link: "https://mybabylogger.com",
    extra: {
      title: "The Math",
      content: "There are roughly 3.6 million babies born in the U.S. every year. If even 2% of new parents use the app at $2.99/month, that's over $2.5M in annual revenue — from one country, one price tier, and zero paid ads."
    }
  },
  {
    id: 3,
    slug: "findthebasketballcourt",
    tagline: "Find a Court. Get a Game.",
    sector: "Sports & Community",
    description: "A court finder helps hoopers find open courts near them, see real-time activity, and connect with other players. No leagues, no fees — just pickup basketball made easier.",
    problem: "There's no reliable way to find a basketball court that's actually open, well-maintained, and has people playing. Google Maps shows parks, not courts — and definitely not whether anyone's running.",
    solution: "A community-powered court finder. Users can search by location, check court conditions, see player activity, and even post when they're heading to a court to get a run going.",
    features: [
      "Map-based court search by location",
      "Court ratings and condition reports",
      "Real-time player check-ins",
      "\"I'm heading there\" game starter",
      "Community reviews and photos"
    ],
    audience: "Pickup basketball players, weekend hoopers, and anyone who's ever driven to a court just to find it locked or empty.",
    category: "Sports & Community",
    link: "https://findthebasketballcourt.com"
  }
];

export const companyValues = [
  {
    title: "Solve Real Problems",
    description: "We start with problems people actually face — not market trends, not investor theses. If it doesn't help someone's day, we don't build it."
  },
  {
    title: "Active Partnership",
    description: "Beyond capital, we provide hands-on technical expertise, strategic guidance, operational support, and access to our extensive network."
  },
  {
    title: "Built to Last",
    description: "We don't build to flip. We build to run, improve, and support for years. Our companies are meant to stick around."
  },
  {
    title: "Community First",
    description: "We build for real communities — parents, believers, ballers. The people who use our tools shape how they grow."
  }
];
